module.exports = __webpack_public_path__ + "images/058f9e63fc1fb7b4649364dcd1703bd3-resetIcon.png";